import { render, staticRenderFns } from "./Serp.vue?vue&type=template&id=7b968f7c&scoped=true&"
import script from "./Serp.vue?vue&type=script&lang=js&"
export * from "./Serp.vue?vue&type=script&lang=js&"
import style0 from "./Serp.vue?vue&type=style&index=0&id=7b968f7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b968f7c",
  null
  
)

export default component.exports